module.exports = __webpack_public_path__ + "fonts/AntikorMono-News.8f0e0563.ttf";